// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./assets/css.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import enums from '@/libs/enums';

Vue.config.productionTip = false;
Vue.directive("title", {
  inserted: function (el, binding) {
    document.title = el.dataset.title;
  },
});

Vue.use(ElementUI);

Vue.filter("clearHtml", (input, len) => {
  if (input == null) {
    return "";
  }

  input = input.replace(/<\/?.+?\/?>/g, "");
  input = input.replace(/&[\w]*;/gi, "");
  input = input.replace(/[ ]/g, "");
  input = input.replace(/[\r\n]/g, "");
  input = input.replace(/(^\s+)|(\s+$)/g, "");
  if (len == 0) {
    return input;
  }
  if (isNaN(len) || len < 0) {
    len = 80;
  }
  if (input && input.length > len) {
    return input.substring(0, len) + "...";
  }
  return input;
});

Vue.prototype.typeJump = function(item) {
  if(item && item.ThirdLink){
    if(item.ThirdLink.AppKind == enums.appKind['应用内部']){
      this.$router.push(item.ThirdLink.Path)
    } else {
      window.location.href = item.ThirdLink.Path;
    }
  }
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js